import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-filter-date',
  templateUrl: './filter-date.component.html',
  styleUrls: ['./filter-date.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FilterDateComponent {
  @Input() set date(value: NgbDate) {
    this._date = value;
  }

  @Input() minDate: NgbDateStruct;
  @Input() maxDate: NgbDateStruct;
  @Output() changeDate: EventEmitter<NgbDate> = new EventEmitter<NgbDate>();

  public _date: NgbDate;

  public onDateSelect(date: NgbDate): void {
    this._date = date;
    this.changeDate.emit(date);
  }
}
